var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#f97316",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212 268 c-7 -7 -12 -20 -12 -30 0 -11 -18 -27 -50 -43 -45 -23 -52 -24 -73 -11 -48 31 -100 -31 -62 -74 20 -23 47 -25 74 -9 25 16 111 -16 111 -42 0 -10 10 -25 21 -33 28 -19 61 -7 74 28 7 22 5 30 -13 48 -19 20 -24 20 -59 9 -33 -11 -45 -10 -81 4 -23 10 -42 23 -42 29 0 7 21 22 46 34 40 20 50 21 80 10 29 -10 36 -9 54 7 38 34 20 85 -30 85 -14 0 -31 -5 -38 -12z m63 -33 c0 -27 -3 -30 -30 -30 -21 0 -31 5 -33 18 -5 25 17 49 42 45 16 -2 21 -10 21 -33z m-195 -70 c20 -25 8 -50 -25 -50 -31 0 -43 20 -31 51 7 18 40 18 56 -1z m195 -100 c0 -25 -4 -30 -24 -30 -28 0 -47 25 -38 49 5 12 16 16 34 14 24 -3 28 -8 28 -33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.9cfa056b0879ec3fd7430f49da6a8718.svg";
export { ForwardRef as ReactComponent };